
const Footer = () => {
    return (
        <div className="footer">
            <div className="copyright">
                <p>Copyright © AdatMarc 2025</p>
            </div>
        </div>
    );
};

export default Footer;
